import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ENTITY_LABEL } from "../../../Helpers/Labels/EntityLabel";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { useChangeBooleans, useFetchedValues, useReferences } from "../../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from "react";
import { usePropsStoreValue } from "../../../../Hooks/PropStore/usePropsStore";
import { getProjectRelations } from "../../../Helpers/Schema/Schema";
import { getEntityPages } from "../../../../API/Display/Display";
import { getPageByProperty } from "../../utils";
import DropDownCell from "./Cells/DropdownCell";
import DeleteCell from "./Cells/DeleteCell";
import ShowCell from "./Cells/ShowCell";
import IdCell from "./Cells/IdCell";
import { DraggableRow } from "../../AttributeTable/Grid/Row/DraggableRow";
import { getAvailablePages, getAvailableRelations, reorderData } from "./utils";
import { useTranslation } from "react-i18next";
import Scrollable from "../../../Shared/Edit/Scrollable";

function ReferenceTable() {

    const selectedComponent = useSelectedComponent();

    const [{ referenceTable: fetchedValues }] = useFetchedValues();
    const [state, dispatch] = useReferences();
    const [, setChangeProperty] = useChangeBooleans();
    const [activeItem, setActiveItem] = useState(null)

    const { t } = useTranslation("display/tables/reference", { useSuspense: false });

    useEffect(() => {
        debugger
        setIsChanged();
    }, [state.references])

    function handleSelect(event) {
        dispatch.selectReference(event.dataItem.id)
    }

    function handleAddClick() {
        dispatch.selectReference(state.references.length + 1)
        dispatch.addNewReferenceRow();
    }

    function handleEntityChange(event, dataItem) {
        dispatch.updateReferenceProperty(dataItem.id, "entity", event.target.value)
        dispatch.updateReferenceProperty(dataItem.id, "relation", null)
        dispatch.updateReferenceProperty(dataItem.id, "page", null)
    }

    function handleRelationChange(event, dataItem) {
        if (dataItem.page && dataItem.page._id === "page-attachment") {
            dispatch.updateReferenceProperty(dataItem.id, "page", null)
        } else if (event.target.value._id === "attachment") {
            const attachmentPage = dataItem.entity.pages.find(page => page._id === "page-attachment")
            dispatch.updateReferenceProperty(dataItem.id, "page", attachmentPage);
        }
        dispatch.updateReferenceProperty(dataItem.id, "relation", event.target.value)
    }

    function handlePageChange(event, dataItem) {
        dispatch.updateReferenceProperty(dataItem.id, "page", event.target.value)
    }

    function handleToggleShow(id) {
        const reference = state.references.find(reference => reference.id === id);
        dispatch.updateReferenceProperty(id, "show", !reference.show);
    }

    function handleDelete(id) {
        dispatch.deleteReference(id);
    }

    function dragStart(dataItem) {
        setActiveItem(dataItem);
    }

    function reorder(dataItem, direction) {
        const reorderedData = reorderData(state.references, activeItem, dataItem, direction);
        dispatch.setReferences(reorderedData);
    }

    function setIsChanged() {
        let isChanged = false;
        let hasErrors = false;
        debugger;
        for (const reference of state.references) {
            if (!reference.entity || !reference.relation || !reference.page) {
                hasErrors = true;
            }
            if (hasErrors) {
                break;
            }
        }
        if (!hasErrors) {
            if (state.references.length !== selectedComponent.referredPages.length) {
                isChanged = true;
            } else {
                for (let index = 0; index < state.references.length; index++) {
                    const reference = state.references[index];
                    if (reference.isNew) {
                        if (
                            reference.entity && reference.entity._id &&
                            reference.relation && reference.relation._id &&
                            reference.page && reference.page._id
                        ) {
                            isChanged = true;
                        }
                    } else {
                        const initialReference = selectedComponent.referredPages[index];
                        if (
                            reference.id !== initialReference.id ||
                            reference.entity._id !== initialReference.entityId ||
                            reference.relation._id !== initialReference.relationId ||
                            reference.page._id !== initialReference.pageId ||
                            reference.show !== initialReference.show
                        ) {
                            isChanged = true;
                        }
                    }
                }
            }
        }
        setChangeProperty("isReferenceTableChanged", hasErrors ? false : isChanged)
    }

    return (
        <div className="h-90">
            <div className="d-flex justify-content-end m-2">
                <button type="button" className="btn btn-outline-primary" onClick={handleAddClick}>
                    <i className="fas fa-plus" /> {t("add_reference_button")}
                </button>
            </div>
            <Scrollable>
                <Grid
                    data={state.references?.map((reference, index) => ({
                        ...reference,
                        '#': index + 1,
                        selected: reference.id === state.selectedReferenceId
                    }))}
                    scrollable="true"
                    selectedField="selected"
                    rowRender={(row, rowProps) => (
                        <DraggableRow
                            elementProps={row.props} {...rowProps}
                            dragStart={dragStart}
                            reorder={reorder}
                        />
                    )}
                    onRowClick={handleSelect}
                >
                    <GridColumn
                        title="#"
                        field="#"
                        width={50}
                        cell={IdCell}
                    />
                    <GridColumn
                        title={t("grid.columns.object_name")}
                        field="entity.label"
                        cell={props => (
                            <DropDownCell
                                {...props}
                                dropdownProps={{
                                    data: fetchedValues.entities,
                                    textField: "label",
                                    dataItemKey: "_id",
                                    value: props.dataItem.entity,
                                    onChange: (event) => handleEntityChange(event, props.dataItem)
                                }}
                            />
                        )}
                    />
                    <GridColumn
                        title={t("grid.columns.relation_name")}
                        field="relation.identifier"
                        cell={props => (
                            <DropDownCell
                                {...props}
                                dropdownProps={{
                                    data: getAvailableRelations(props.dataItem.entity.relations, state.references),
                                    textField: "identifier",
                                    dataItemKey: "_id",
                                    value: props.dataItem.relation,
                                    onChange: (event) => handleRelationChange(event, props.dataItem)
                                }}
                            />
                        )}
                    />
                    <GridColumn
                        title={t("grid.columns.page_name")}
                        field="page.pageName"
                        cell={props => (
                            <DropDownCell
                                {...props}
                                dropdownProps={{
                                    data: getAvailablePages(props.dataItem),
                                    textField: "pageName",
                                    dataItemKey: "_id",
                                    value: props.dataItem.page,
                                    onChange: (event) => handlePageChange(event, props.dataItem)
                                }}
                            />
                        )}
                    />
                    <GridColumn
                        title=""
                        field=""
                        cell={props => (
                            <ShowCell
                                {...props}
                                onToggleShow={handleToggleShow}
                            />
                        )}
                        width={30}
                    />
                    <GridColumn
                        title=""
                        field=""
                        cell={props => (
                            <DeleteCell
                                {...props}
                                onDelete={handleDelete}
                            />
                        )}
                        width={30}
                    />
                </Grid>
            </Scrollable>
        </div>
    )
}

export default ReferenceTable;